<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
  import Slider from '../components/Slider.svelte'
  import AnimatedLine from '../components/AnimatedLine.svelte'

  let slideData = [
    {
      caption: 'Leverage our best-in-class identity graph and first-party data for holistic, cross-device management',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img1-mobile_i8ywbl.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img1-desktop_wybywc.jpg',
      altText: 'Man on couch pointing remote control at TV'
    },
    {
      caption: 'Run CTV ads on major networks and publishers, including live TV, as well as first-in-market self-serve access to Household Addressable TV across DISH and Fios.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img2-mobile_yfmalt.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img2-desktop_znq9op.jpg',
      altText: '2 girls laying on a rug watching TV'
    },
    {
      caption: 'Understand the optimal mix of CTV to Linear TV using our Cross-Screen Planner and robust measurement options.',
      mobileImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img3-mobile_eavmwj.jpg',
      desktopImage: 'https://res.cloudinary.com/tanka-design/image/upload/q_auto/v1615930600/VerizonMediaATV/linear-lockscroll2-img3-desktop_a5fbsx.jpg',
      altText: 'Child laying on a rug watching TV'
    },
  ]
</script>

<section class="part9 no-max-width">
  <div class="content">
    <div class="rgrid-md-1-2">
      <div class="col">
        <AnimatedLine size={5} color="white"></AnimatedLine>
        <AnimatedTitle class="large">Make your TV strategy more strategic.</AnimatedTitle>
        <AnimatedBlock>
          <p class="subtitle">Connect the dots between your linear TV and Connected TV strategies with the Verizon Media DSP:</p>
        </AnimatedBlock>
      </div>
    </div>
  </div>
  <div class="slider-wrap">
    <Slider slides={slideData} useFullWidth={true} />
  </div>
</section>

<style>
  .part9 :global(.subtitle) {
    font-weight: 500;
  }
  section :global(.hline) {
    margin-bottom: 0.625rem;
  }
  .slider-wrap {
    margin-top: 3rem;
  }
</style>
